import React from 'react';

const context = React.createContext({ paddingBottomRight: [0, 0] });

export default context;
